<template src="./templates/Pagination.html" />

<script setup>

import { computed } from 'vue';

import {
    usePagination,
    useQueryParamsStore,
    useResultsStore,
} from '@timezoneone/dottie-client-jam';

const queryParams = useQueryParamsStore();
const resultsStore = useResultsStore();

const {
    currentPage,
    gotoPage,
    totalPages,
} = usePagination(queryParams, resultsStore);

// Function to scroll to the top of the element with ID 'dottie-results-grid'
const scrollToResultsGrid = () => {

    const element = document.getElementById('dottie-results-grid');
    if (element) {

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offset = window.innerWidth > 752 ? 90 : 16; // 80px offset for desktop, 16 for mobile
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });

    }

};

// Compute the list of displayed page numbers with ellipsis
const displayedPages = computed(() => {

    const totalDisplayPages = 5; // Number of pages to display (including ellipsis)

    if (totalPages.value <= totalDisplayPages) {

        // If there are fewer pages than the display limit, show all pages
        return Array.from({ length: totalPages.value }, (_, index) => index + 1);

    }

    // Determine the current page's position in the pagination
    // eslint-disable-next-line
    const position = currentPage.value < 3 ? 'start' : (currentPage.value >= (totalPages.value - 2) ? 'end' : 'middle');

    switch (position) {

    case 'start':

        // Display pages 1 to (totalDisplayPages - 1), followed by ellipsis and the last page
        return [1, 2, 3, 4, '...', totalPages.value];

    case 'middle':

        // Display current page, one page before, one page after, ellipsis, and first/last pages
        return [
            1,
            '...',
            currentPage.value - 1,
            currentPage.value,
            currentPage.value + 1,
            '...',
            totalPages.value,
        ];

    case 'end':

        // Display the first page, ellipsis, and pages (totalPages.value - (totalDisplayPages - 1)) to totalPages.value
        return [1, '...', totalPages.value - 3, totalPages.value - 2, totalPages.value - 1, totalPages.value];

    default:

        return [];

    }

});

</script>
